exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ft-row[data-v-4f26f009]{display:flex;flex-wrap:wrap;border-top:1px solid #ddd;border-left:1px solid #ddd}", ""]);

// exports
